import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Stack, Typography } from '@mui/material';

const LoadingRow = ({ label }) => (
  <Stack direction="row" alignItems="center" spacing={1}>
    <CircularProgress size={14} />
    <Typography variant="body2" color="text.secondary">{label}</Typography>
  </Stack>
);

LoadingRow.propTypes = {
  label: PropTypes.string.isRequired,
};

export default LoadingRow;
